const time = {
  mask: '##:## Pm',
  tokens: {
    P: {
      pattern: /[(a|p)]/
    }
  }
}

export default time
